<template>
<ul class="micad_resultsList">
  <li v-for="result in results" :key="result" class="micad_resultsList_result">{{result}}</li>
</ul>
</template>

<script>
export default {
  name: 'ResultsList',
  data() {
    return {
      results: ["Results item 1","Reslult item 2","Result item 3"],
      query: "item 2",
    }
  },
  /*computed: {
    highlight: function () {
      return this.query
    }
  }*/
}
</script>
